"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  pageHeader: {
    position: props => {
      return props.position;
    },
    zIndex: 2,
    height: "6em",
    padding: "2em 4em",
    color: "white",
    display: "flex",
    alignItems: "center"
  },
  pageTitle: {
    fontSize: "2em"
  }
}));

const KioskPageHeader = ({
  title,
  position = "relative"
}) => {
  const classes = useStyles({
    position
  });
  return _react.default.createElement("header", {
    className: classes.pageHeader
  }, _react.default.createElement(_Typography.default, {
    className: classes.pageTitle
  }, title));
};

var _default = KioskPageHeader;
exports.default = _default;
module.exports = exports.default;